import contact from './contact';

export default {
  init() {
    contact.handleContactForm();

    this.pollScore = 0;
    this.pollCount = $('.poll').data('questions');
    this.pollThreshold = $('.poll').data('threshold');
    this.processPoll();
    this.restartPoll();
  },
  processPoll() {
    const that = this;
    const progressBar = $('.progress-bar');

    $('.poll').find('.next').on('click', function(e) {
      e.preventDefault();
      const btn = $(this);
      const container = btn.closest('.question');
      const checked = container.find('input:checked');

      if(container.hasClass('multi-select')) {
        if(checked.length === 0) {
          return false;
        }

        $.each(checked, function(_, input) {
          if ($(input).val() === '1') {
            btn.data('value', 1);
            return false;
          }
        });
      }

      container.fadeOut(200, function() {
        container.next().fadeIn(500);
      });
      progressBar.css('width', ((100 / that.pollCount) * container.next().data('index')) + '%');
      that.pollScore = that.pollScore + btn.data('value');

      if(container.next().length === 0) {
        if (that.pollScore >= that.pollThreshold) {
          $('.questions').fadeOut(200, function() {
            $('.result-ok').fadeIn(500);
          });
        } else {
          $('.questions').fadeOut(200, function() {
            $('.result-ko').fadeIn(500);
          });
        }
      }
    });
  },
  restartPoll() {
    const that = this;
    const progressBar = $('.progress-bar');

    $('.poll').find('.restart').on('click', function(e) {
      e.preventDefault();

      that.pollScore = 0;
      $('.multi-select').find('.next').data('value', 0);
      $('.question').find('input').prop('checked', false);
      $('.result:visible').fadeOut(200, function() {
        $('.questions').add('.question:eq(0)').fadeIn(500);
      })
      progressBar.css('width', (100 / that.pollCount) + '%');
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/singleDataGuide.js